import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { Measure, Series } from './types';

interface KPITableProps {
  data?: Measure[];
  series?: Series[];
  handleSelect: (selected: Measure | null) => void;
  selected: Measure | null;
}

const KPITable = ({ data, series = [], handleSelect, selected }: KPITableProps) => {
  const handleClick = (event: React.MouseEvent<unknown>, newSelected: Measure) => {
    handleSelect(selected === newSelected ? null : newSelected);
  };

  return (
    <TableContainer component={Paper} style={{ height: '100%' }} data-testid="KPITable-container">
      <Table aria-label="kpi table">
        <TableHead>
          <TableRow data-testid="KPITable-header">
            <TableCell>Name</TableCell>
            {series.map(serie => (
              <TableCell align="right" key={serie.displayName || serie.name}>
                {serie.displayName || serie.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map(row => {
              const isItemSelected = selected?.id === row.id;

              return (
                <TableRow
                  data-testid="KPITable-row"
                  key={row.id}
                  onClick={event => handleClick(event, row)}
                  selected={isItemSelected}
                >
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  {series.map(serie => (
                    <TableCell key={serie.name} align="right">
                      {row[serie.displayName || serie.name]}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default KPITable;
